import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthSubscriptionService {
    public guid: string;
    private authChangeSub = new BehaviorSubject<boolean>(false);
    public authChanged = this.authChangeSub.asObservable();

    constructor() {
        this.guid = crypto.randomUUID();
    }

    public sendAuthStateChangeNotification = (isAuthenticated: boolean) => {
        this.authChangeSub.next(isAuthenticated);
    };
}